import React, { useState, useRef } from "react";
import {
  Plus,
} from "lucide-react";
import { LayoutMain } from "../LayoutMain";
import { ModalCita } from "../../components/ModalCita";
import { TablaPacientes } from "../../components/TablaCitas";


export const AgendaCitas = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const idUser = JSON.parse(localStorage.getItem("auth")).idUser;

  const modal = useRef();

  
  return (
    <div>
      <title>Agenda de Citas</title>
      <LayoutMain titleItem={"AgendaCitas"}>
        <div className="space-y-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div>
              <h2 className="text-2xl font-bold text-slate-800">
                Gestión de Citas
              </h2>
              <p className="text-xs text-slate-500">
                Administración de la agenda
              </p>
            </div>
            <button
              onClick={() => modal.current.open()}
              className="bg-gradient-to-r from-cyan-600 to-blue-600 text-white font-semibold px-4 py-2 rounded-xl text-sm shadow-md flex items-center justify-center gap-2"
            >
              <Plus className="w-4 h-4" /> Agendar Nueva Cita
            </button>
          </div>
          
          <TablaPacientes idNegocio={idNegocio} />

        </div>
      </LayoutMain>

      <ModalCita
        ref={modal}
        idNegocio={idNegocio}
        tipoHorario={"horarioLibre"}
        idUser={idUser}
        nuevaCita={true}
        nomPaciente={""}
      />
    </div>
  );
};
